export type User = {
  id: string;
  username: string;
  fullname: string;
  email: string;
  isEnabled: boolean;
  isLockedOut: boolean;
  roles: string[];
  clientId: string | null;
  jobTitle: string | null;
  phoneNumber: string | null;
  clientName: string | null;
  createdByPlatform: Platform;
  clientCode?: string;
  createdByPlatformLabel?: string;
};

export type Authorization = {
  refresh_token: string;
  expires_in: number | string;
  access_token: string;
  token_type?: string;
};

export type CustomErrorResponse = {
  data?: {
    error?: string;
    message?: string;
    [key: string]: any;
  };
  status?: number;
};

export type AuthState = {
  user: User | null;
  loading: boolean;
  error?: CustomErrorResponse | string | null;
  resetPasswordSuccess?: boolean;
  userSignUp?: boolean;
};

export function isCustomError(error: unknown): error is CustomErrorResponse {
  return typeof error === 'object' && error !== null && 'status' in error;
}

export enum Platform {
  Unknown = 0,
  Backoffice = 1,
  Portal = 2,
}
